/**
 * Shared MUI DataGrid sx overrides for full-cell tile colouring.
 *
 * DataGrid cells have default horizontal padding, which leaves side gaps
 * when a renderCell Box paints background color. Zeroing the cell padding
 * for targeted fields lets the tile background fill the entire cell.
 */
export const tileColorSx = {
  "& .MuiDataGrid-cell[data-field='departureDelay']": {
    padding: '0 !important',
  },
  "& .MuiDataGrid-cell[data-field='salesDay']": { padding: '0 !important' },
};
